import _ from "lodash";

/*
	Shop mode — the maintenance switch of the shop.

	Three values, the same ones the ltoys shop uses, so
	`erpcli -s es|ltoys shop mode ...` means the same thing on both:

		normal       the shop sells
		catalog      the catalog stays readable, but nothing can be put into
		             the cart, ordered, registered or changed in the profile
		maintenance  the shop is closed and shows a maintenance page

	The single source of truth is the `SHOP_MODE` document of the
	`shop_setting` collection; the backend hands the normalized value to the
	frontend through /api/app_info (state.appInfo.SHOP_MODE) and refuses the
	matching write endpoints itself. The helpers below only drive the UI.
*/

export const SHOP_MODE_NORMAL = "normal";
export const SHOP_MODE_CATALOG = "catalog";
export const SHOP_MODE_MAINTENANCE = "maintenance";

// names used before the modes were aligned with the ltoys shop
const SHOP_MODE_ALIASES = {
	default: SHOP_MODE_NORMAL,
	view_only: SHOP_MODE_CATALOG,
};

export const getShopMode = (state) => {
	const raw = _.get(state, "appInfo.SHOP_MODE", SHOP_MODE_NORMAL);
	const mode = _.toLower(_.trim(raw));
	return _.get(SHOP_MODE_ALIASES, mode, mode);
};

/* True whenever writing is off — `maintenance` closes the shop entirely, so it
   implies everything `catalog` restricts. */
export const isCatalogMode = (state) =>
	[SHOP_MODE_CATALOG, SHOP_MODE_MAINTENANCE].indexOf(getShopMode(state)) >= 0;

export const isMaintenanceMode = (state) =>
	getShopMode(state) === SHOP_MODE_MAINTENANCE;

/*
	Ready-made mapStateToProps fragment, so a component that already has its
	own connect() just spreads it in instead of stacking another HOC:

		connect((state) => ({...mapShopModeToProps(state), ...}))
*/
export const mapShopModeToProps = (state) => ({
	catalogMode: isCatalogMode(state),
});
